export default [
    {
        path: '/scheduler/storage',
        name: 'StorageScheduler',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Storage schedule',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/scheduler/storage/SchedulerIndex.vue'),
            agent: () => import('@views/scheduler/storage/SchedulerIndex.vue'),
        },
    },
];
